import { useEffect } from 'react';

export default function SeenObserver({ chatId, messageId, userId, messageRefs, socket }) {
  useEffect(() => {
    const ref = messageRefs.current.get(messageId)?.current;
    if (!ref) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          socket.emit('seen', { chatId, messageId, userId });
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(ref);
    return () => observer.disconnect();
  }, [chatId, messageId, userId, messageRefs]);
  return null;
}
